import { useEffect } from 'react';

/**
 * Custom hook to load the Smart Tile status page script
 * Handles loading and cleanup automatically
 */
const useStatusPageScript = () => {
  useEffect(() => {
    // Check if script is already loaded to avoid duplicates
    const existingScript = document.querySelector('script[src="https://smarttile.statuspage.io/embed/script.js"]');
    
    if (!existingScript) {
      // Load Smart Tile status page script
      const script = document.createElement('script');
      script.src = 'https://smarttile.statuspage.io/embed/script.js';
      script.async = true;
      document.head.appendChild(script);
    }

    // Cleanup function to remove script when component unmounts
    return () => {
      const scriptToRemove = document.querySelector('script[src="https://smarttile.statuspage.io/embed/script.js"]');
      if (scriptToRemove) {
        document.head.removeChild(scriptToRemove);
      }
    };
  }, []);
};

export default useStatusPageScript;